
<!-- nav bar  <router-outlet></router-outlet>  -->

<div class="view">
<!-- Below is the code for Password checking -->
<!-- <div class="view" *ngIf="mainContent"> -->
  <section><img src="assets/001.jpg" alt=""></section>
  <section><img src="assets/002.jpg" alt=""></section>
  <section><img src="assets/003.jpg" alt=""></section>
  <section><img src="assets/004.jpg" alt=""></section>
  <section><img src="assets/005.jpg" alt=""></section>
  <section><img src="assets/006.jpg" alt=""></section>
  <section><img src="assets/007.jpg" alt=""></section>
  <section><img src="assets/008.jpg" alt=""></section>
  <section><img src="assets/009.jpg" alt=""></section>
  <section><img src="assets/010.jpg" alt=""></section>
  <section><img src="assets/011.jpg" alt=""></section>
  <section><img src="assets/012.jpg" alt=""></section>
  <section><img src="assets/013.jpg" alt=""></section>
  <section><img src="assets/014.jpg" alt=""></section>
  <section><img src="assets/015.jpg" alt=""></section>
  <section><img src="assets/016.jpg" alt=""></section>
  <section><img src="assets/017.jpg" alt=""></section>
  <section><img src="assets/018.jpg" alt=""></section>
  <section><img src="assets/019.jpg" alt=""></section>
  <section><img src="assets/020.jpg" alt=""></section>
  <section><img src="assets/021.jpg" alt=""></section>
  <section><img src="assets/022.jpg" alt=""></section>
  <section><img src="assets/023.jpg" alt=""></section>
  <section><img src="assets/024.jpg" alt=""></section>
  <section><img src="assets/025.jpg" alt=""></section>
  <section><img src="assets/026.jpg" alt=""></section>
  <section><img src="assets/027.jpg" alt=""></section>
  <section><img src="assets/028.jpg" alt=""></section>
  <section><img src="assets/029.jpg" alt=""></section>
</div>
<!-- take off check passcode start from this line and belog-->
<!-- <div class="disloagBg" *ngIf="showBg"></div>
<div class="disloag" *ngIf="showDialog">
  <h1>Private Section</h1>
  <span class="partition"></span>
  <form #userForm="ngForm" (ngSubmit)="onSubmit()" novalidedate>
    <label class="title">Please provide your passcode</label>
    <input type="text" class="pass-code from-group" #paddcode="ngModel"
           name="passcode" [(ngModel)]="userModel.passcode" required
           placeholder="Pass Code" aria-label="passcode" autocomplete="off">
      <span class="text-danger" [class.d-none]="paddcode.valid || paddcode.untouched">
        <i class="material-icons">error_outline</i>Passcode is required.
      </span>
      <span class="text-danger" *ngIf="showError">
        <i class="material-icons">error_outline</i>Passcode is incorrect.
      </span>

    <button [disabled]="userForm.form.invalid" class="btn btn-primary">Submit</button>
    <div class="contact">
      <div class="text-justify">
        <a href = "mailto: mwjjui@gmail.com">
          <span class="material-icons">mail</span>
          contact for the passcode</a>
      </div>
    </div>
  </form>
</div> -->


